import {PublicAdsApi} from '@frontend/modules/public/ads/PublicAdsApi'
import type {
    ExecutorDetailsData,
    ExecutorPreviewData,
    ExecutorReviewData,
} from '@frontend/modules/public/services/ServicesModuleTypes'
import type {ReviewsListRatingBreakdownItemData} from '@frontend/modules/public/shared/reviews/ReviewsModuleTypes'
import type {ApiResponseData} from '@frontend/types/AppTypes'
import {ApiRequestService} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'

// API опубликованных исполнителей услуг.
export const PublicExecutorsApi = {

    // Получить полные данные исполнителя услуг.
    async getExecutorDetails(id: number, abortController?: AbortController): Promise<ExecutorDetailsData> {
        return ApiRequestService
            .get<ExecutorDetailsResponseData>(
                `/v1/executor/${id}`,
                undefined,
                undefined,
                abortController
            )
            .then(response => response.data.executor)
    },

    // Получение номера телефона исполнителя услуг.
    async getExecutorPhone(id: number, abortController?: AbortController): Promise<string> {
        return ApiRequestService
            .post<ExecutorPhoneResponseData>(
                `/v1/executor/${id}/phone`,
                undefined,
                undefined,
                abortController
            )
            .then(response => response.data.phone)
    },

    // Получить исполнителей услуг, похожих на текущего.
    async getSimilarExecutors(
        id: number | null,
        categoryId: number,
        limit: number,
        offset: number = 0,
        abortController?: AbortController
    ): Promise<ExecutorPreviewData[]> {
        return ApiRequestService
            .get<ExecutorsListResponseData>(
                '/v1/executors/similar',
                {
                    id,
                    categoryId,
                    limit,
                    offset,
                },
                undefined,
                abortController
            )
            .then(response => response.data.records)
    },

    // Получить отфильтрованный список исполнителей услуг.
    async getServiceOwnerExecutors(
        serviceOwnerId: number,
        limit: number = 20,
        offset: number = 0,
        abortController?: AbortController
    ): Promise<Pick<ExecutorsListResponseData, 'records' | 'count'>> {
        return PublicAdsApi.getFilteredItems(
            null,
            'services',
            {
                sellerId: String(serviceOwnerId),
            },
            limit,
            offset,
            'list',
            abortController
        )
            .then(response => ({
                records: response.executors ?? [],
                count: response.executorsCount ?? 0,
            }))
    },

    // Получить список отзывов об исполнителе услуг.
    async getReviews(
        executorId: number,
        limit: number,
        offset: number = 0,
        abortController?: AbortController
    ): Promise<ExecutorReviewsListResponseData> {
        return ApiRequestService
            .get<ExecutorReviewsListResponseData>(
                `/v1/executor/${executorId}/reviews`,
                {
                    limit: String(limit),
                    offset: String(offset),
                },
                undefined,
                abortController
            )
            .then(response => response.data)
    },
}


export interface ExecutorsListResponseData extends ApiResponseData {
    records: ExecutorPreviewData[]
    count: number
}

interface ExecutorDetailsResponseData extends ApiResponseData {
    executor: ExecutorDetailsData
}

interface ExecutorPhoneResponseData extends ApiResponseData {
    phone: string
}

interface ExecutorReviewsListResponseData extends ApiResponseData {
    records: ExecutorReviewData[]
    ratingBreakdown: ReviewsListRatingBreakdownItemData[] | null
}
